import React from 'react'

interface OrderDetailLoaderProps {
  message?: string
}

/**
 * 🔄 Компонент анимации загрузки для деталей заказа
 * Красивая анимация с вращающимися орбитами
 */
export const OrderDetailLoader: React.FC<OrderDetailLoaderProps> = ({ 
  message = "Загрузка заказа..." 
}) => {
  return (
    // Контейнер на весь экран с фиксированным позиционированием для правильного центрирования
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 p-4 font-sans text-black">
      {/* Основной контейнер */}
      <div className="relative p-4 flex flex-col items-center justify-center">

        {/* Контейнер для вращающихся орбит */}
        <div className="relative w-16 h-16 flex items-center justify-center">
          {/* Орбита 1 - внешняя */}
          <div className="absolute w-16 h-16 rounded-full border-2 border-dashed border-blue-400 animate-[spin_10s_linear_infinite]"></div>
          {/* Орбита 2 - средняя */}
          <div className="absolute w-12 h-12 rounded-full border-2 border-dotted border-indigo-500 animate-[spin_6s_linear_infinite_reverse]"></div>
          {/* Орбита 3 - внутренняя */}
          <div className="absolute w-6 h-6 rounded-full border-2 border-slate-600 animate-[spin_4s_linear_infinite]"></div>
          
          {/* Центральная точка */}
          <div className="absolute w-2 h-2 rounded-full bg-blue-600 animate-pulse"></div>
        </div>
        
        {/* Текст */}
        <p className="mt-6 text-base font-light text-slate-700 tracking-widest animate-pulse">
          {message}
        </p>
      </div>
    </div>
  )
}

export default OrderDetailLoader
